/*
 *@Description:公共配置
 *@Author: zhengff
 *@Date: 2019-05-11 10:17:41
 */
import {
  Cache
} from '$utils'

const common = {
  state: {
    // 面包屑
    breadcrumb: Cache.get('BREADCRUMB') || [],
    alarmDate: {},
    alarmNewList: {},
    fireAlarmNewList: {},
    identifyAlarmList: [],
    strangerList: {},
    reserveDetail: {},
    alarmCount: [],
    showChildrenMenus: false
  },
  actions: {
    // 根据菜单层级显示面包屑
    SetBreadcrumb({
      commit
    }, data) {
      commit('SET_BREADCRUMB', data)
    },
    SetAlarmData({
      commit
    }, data) {
      commit('SET_ALARMDATA', data)
    },
    ShowChildrenMenus({
      commit
    }, data) {
      commit('SHOW_CHILDREN_MENUS', data)
    }
  },
  mutations: {
    /*
     *@name: 设置面包屑
     *@param:{object} state 状态 {object} data 数据
     *@description:
     *@return:无
     *@author: zhengff
     *@date: 2019-05-11 10:16:34
     */
    SET_BREADCRUMB: (state, data) => {
      Cache.put('BREADCRUMB', data)
      state.breadcrumb = data
    },
    SET_ALARMDATA: (state, data) => {
      state.alarmDate = data
    },
    SHOW_CHILDREN_MENUS: (state, data) => {
      state.showChildrenMenus = data
    }
  }
}
export default common